import { useEffect, useState } from 'react'
import { getPortaria } from './portariaApi'

export function PersonPhoto({ clientId, personId, name }: { clientId: string; personId: string; name: string }) {
  const [photo, setPhoto] = useState('')
  const [open, setOpen] = useState(false)
  useEffect(() => {
    let active = true
    setPhoto('')
    getPortaria<{ profile?: { photoBase64?: string } }>(clientId, `people/${personId}`).then(data => {
      if (active && data.profile?.photoBase64) setPhoto(`data:image/jpeg;base64,${data.profile.photoBase64}`)
    }).catch(() => {})
    return () => { active = false }
  }, [clientId, personId])
  return <><button type="button" className="person-directory-photo" disabled={!photo} onClick={() => setOpen(true)} aria-label={`Ampliar foto de ${name}`}>{photo ? <img src={photo} alt={`Foto de ${name}`} /> : <span aria-hidden="true">♙</span>}</button>
    {open && <div className="person-photo-overlay" role="dialog" aria-modal="true" aria-label={`Foto de ${name}`} onClick={() => setOpen(false)} onKeyDown={event => { if (event.key === 'Escape') setOpen(false) }}><div onClick={event => event.stopPropagation()}><h3>{name}</h3><img src={photo} alt={`Foto de ${name}`} /><button autoFocus type="button" onClick={() => setOpen(false)}>Fechar</button></div></div>}</>
}
